export enum nivedanStatus {
  NEW = 'NEW',
  ASSIGNED = 'ASSIGNED',
  IN_REVIEW = 'IN_REVIEW',
  RESPONSE_PENDING = 'RESPONSE_PENDING',
  RESOLVED = 'RESOLVED',
  DRAFT = 'DRAFT'
}